export default __webpack_public_path__ + "static/media/transferring.446449d0.svg";